"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const getStateContentType_1 = require("../../helpers/getStateContentType");
const validateUser_1 = require("../../helpers/validateUser");
const generateSortKey_1 = tslib_1.__importDefault(require("../helpers/generateSortKey"));
exports.defaultDate = new Date('1000-01-01T00:00:00Z').toISOString();
const baseZeroState = (content, user) => {
    validateUser_1.validateUser(user);
    const currentDate = new Date().toISOString();
    return {
        contentType: getStateContentType_1.getStateContentType(content.offerType),
        userId: user.userId,
        rootContentId_contentId: generateSortKey_1.default(content.rootOfferId.toString(), content._id.toString()),
        companyId: user.companyId,
        contentId: content._id,
        rawScore: 0,
        scaledScore: 0,
        progressMeasure: 0,
        scaledProgressMeasure: 0,
        completionStatus: 'notAttempted',
        successStatus: 'na',
        forceComplete: false,
        timeSpent: 0,
        submissionCount: 0,
        lastUpdatedTimeSpent: exports.defaultDate,
        lastSubmittedOn: exports.defaultDate,
        createdAt: currentDate,
        updatedAt: currentDate,
        startedOn: exports.defaultDate,
        lastAccessedOn: exports.defaultDate,
        successOn: exports.defaultDate,
        completedOn: exports.defaultDate,
        versionNumber: 0
    };
};
exports.default = baseZeroState;
//# sourceMappingURL=baseZeroState.js.map